<template>
  <div class="w-100">
    <SvgGridOverlay v-if="data.isSvg" :data="data" />
    <MakerContentOverlay v-else-if="data.isMaker" :data="data" />
    <EditableOnlineOverlay v-else-if="data.isEditableOnline" :data="data" />
    <CommonOverlay v-else :data="data" />
  </div>
</template>

<script>
import CommonOverlay from '@/components/Vectors/CommonOverlay';
import SvgGridOverlay from '@/components/Vectors/SvgGridOverlay';
import MakerContentOverlay from 'UI/Content/MakerContentOverlay';
import EditableOnlineOverlay from '@/components/Vectors/EditableOnlineOverlay.vue';

export default {
  components: {
    CommonOverlay,
    SvgGridOverlay,
    MakerContentOverlay,
    EditableOnlineOverlay
  },
  props: {
    data: {
      type: Object,
      required: true
    }
  }
};
</script>
